module.exports = __webpack_public_path__ + "static/media/clinician-watchman-device-400w.784467fe.webp";